export default {"src":"/bnb/_next/static/media/bnbx-dark.030806d7.svg","height":24,"width":24};